import type { AppConfig } from '../types/app-config.types';

function mergeNamespace<TNamespace extends Record<string, unknown> | undefined>(
	baseNamespace: TNamespace,
	overrideNamespace: TNamespace
): TNamespace {
	if (!baseNamespace && !overrideNamespace) {
		return undefined as TNamespace;
	}

	const nextNamespace: Record<string, unknown> = {
		...(baseNamespace ?? {})
	};

	Object.entries(overrideNamespace ?? {}).forEach(([key, value]) => {
		if (value !== undefined) {
			nextNamespace[key] = value;
		}
	});

	return nextNamespace as TNamespace;
}

export function mergeAppConfig(
	baseConfig: AppConfig,
	overrideConfig: AppConfig
): AppConfig {
	return {
		shared: mergeNamespace(baseConfig.shared, overrideConfig.shared),
		portal: mergeNamespace(baseConfig.portal, overrideConfig.portal),
		creator: mergeNamespace(baseConfig.creator, overrideConfig.creator),
		vibeBuilder: mergeNamespace(
			baseConfig.vibeBuilder,
			overrideConfig.vibeBuilder
		)
	};
}
